import './App.css';
import HeroSection from './sections/HeroSection';
import InfoSection from './sections/InfoSection'
import ProductSection from './sections/ProductSection';
import GallerySection from './sections/GallerySection';
import SupportSection from './sections/SupportSection';
import FooterSection from './sections/FooterSection';
function App() {
  return (
    <div className="App">
      <header>
        {/* You can add navigation or title here if needed in the future */}
      </header>
      <HeroSection />
      <InfoSection />
      <ProductSection />
      <GallerySection />
      {/* <SupportSection />
      <FooterSection /> */}
    </div>
  );
}

export default App;
